<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <TawkTurnstileGate />
  </div>
</template>

<script setup lang="ts">
const route = useRoute()
const config = useConfigStore()
const turnstileScriptUrl = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit'

const notifyTurnstileLoaded = () => {
  window.dispatchEvent(new Event('turnstile-loaded'))
}

useHead({
  script: [
    {
      id: 'turnstile-script',
      src: turnstileScriptUrl,
      async: true,
      defer: true,
      onload: notifyTurnstileLoaded,
    },
  ],
})

watch(
  () => route.path,
  (routePath) => {
    config.retainQueriesForRoute(routePath)
  },
  { immediate: true, flush: 'post' }
)
</script>

<style>
body {
  font-family: var(--font-family);
  font-size: var(--sats-font-size-body);
  margin: 0;
  /* background-color: blue */
  /* background-color: var(--indigo-400); */
  /* background-color: var(--surface-100); */
  background-color: rgb(248 248 248);
}

.page-enter-active,
.page-leave-active {
  transition: opacity 0.1s ease;
}

.page-enter-from,
.page-leave-to {
  opacity: 0;
}
</style>
